import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { NgIf, NgFor } from "@angular/common";

export interface age{
    min:number;
    max:number;
};
@Component({
    selector: 'app-age-filter-block',
    templateUrl: './ageFilterBlock.component.html',
    styleUrls: ['./ageFilterBlock.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, FormsModule, TranslateModule]
})

export class AgeFilterBlockComponent implements OnInit{
    isDisplayed:boolean = false;
    @Input() ageSelected:age;
    selectedAgeIndex:number = null;
    // selectedAge: age;

    ages: age[] = [
        {min:0, max:19},
        {min:20, max:24},
        {min:25, max:34},
        {min:35, max:44},
        {min:45, max:54},
        {min:55, max:64},
        {min:65, max:999}
    ];
    
    toggleVisibility(){
        this.isDisplayed = !this.isDisplayed;
    }
    
    hide(){
        if(this.isDisplayed) this.isDisplayed = false;
    }

    show(){
        if(!this.isDisplayed) this.isDisplayed = true;
    }

    getSelectedAge():age{
        return this.ages[this.selectedAgeIndex];
    }
    
    ngOnInit(): void {
        if (this.ageSelected) {
            for (let i = 0; i < this.ages.length; i++) {
                if (this.ages[i].min === this.ageSelected.min && this.ages[i].max === this.ageSelected.max) {
                    this.selectedAgeIndex = i;
                    break;
                }
            }
        }
    }
}